import {RegisterLegacyAction} from '@netx/core/legacyActionManager';
import AppViewsCollection from '../collections/appViews';
import AppModalView from '../views/appModalView';

export const modalViews = new AppViewsCollection([]);

export const modalView = new AppModalView({
	viewCollection: modalViews,
});

RegisterLegacyAction([
	{
		event: 'app:remove:modalView',
		label: '',
		wrapper: (v: any) => {
			return [v.model];
		},
	},
]);

/**
 * @event module:app#app:remove:modalView
 * @param {Netx.Models.AppView} appView App view model
 */
dispatcher.on('app:remove:modalView', function (appView: any) {
	const view = appView.get('view');
	if (!view) return;

	// Vars
	const modalOpts = view.modalOptions || {};
	const activeView = modalViews.findWhere({active: true}) as any;
	const activeViewModalOpts =
		activeView && activeView.modalOptions ? activeView.modalOptions : {};

	// Can't do that while blocking
	if (modalOpts.blocking === true || activeViewModalOpts.blocking === true) {
		return;
	}
	// Let the view know it has been `cancelled`
	// Allows us to utlize the standard event system
	if (view.hasFunctionality('form') && typeof view.cancel === 'function') {
		appView.collection._listenId === modalViews._listenId && view.cancel();
		return;
	} else {
		// Will remove from modal childViews
		modalViews.remove(appView.id);
		// Let the hide stuff run so we do not get jerky results
		// all modal views are set to remove on hidden so long as the simple param is not passed
		// view.hide();
	}
});
/**
 * Removes all modal views (and in turn closes modal if open)
 * @event module:app#app:reset:modalViews
 */
dispatcher.on('app:reset:modalViews', function () {
	modalViews.set([]);
});

export default modalViews;
